import {FormType} from '../../../../../blocks/FormBlock'
import {copy} from '../../../../../../util/fieldscopy'

const zip: FormType = {
	id: 9,
	parent_id: 0,
	channel: 'input',
	name: 'postcode',
	label: copy?.zip || 'Postcode',
	required: true,
	type: 'text',
	mod: 'half',
	placeholder: ''
}

export default zip
